import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const meetingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/meetings",
  component: lazyRouteComponent(() => import("./meetings.page.js"), "MeetingsPage"),
});
